const fileRootPathMixin = {

    data() {

        return {

            fileRootPath: this.$page.props.fileRootPath,

        };

    },

};

export default fileRootPathMixin;
